// Generated by IcedCoffeeScript 108.0.11
(function() {
  var C, pjs;

  C = require('./const');

  pjs = require('../package.json');

  exports.header = {
    version: C.header.version + (" v" + pjs.version),
    comment: C.header.comment
  };

}).call(this);
